import { useLocation } from "react-router-dom";
import type { KitBugReportPageProps } from "@jkast90/kast-common/account";
import { BugReportPage as KitBugReportPage } from "@common/account";

const HEAD = (
  <div className="library-head">
    <h1>Report a bug</h1>
  </div>
);

type Props = Pick<KitBugReportPageProps, "initialDescription" | "navigationState">;

/**
 * The report page, with no router or store hooks, so the app-level crash
 * screen can show it outside the providers. Reports go to the kast-dev
 * admin inbox, not CloudBoy's API. The logs are shown beside the form to
 * admins with admin tools on.
 */
export function BugReport(props: Props) {
  return <KitBugReportPage title={null} intro={HEAD} logsTitle="Attached logs" {...props} />;
}

/** /bug-report: pre-filled when arriving from a crash screen's Report This. */
export default function BugReportPage() {
  return <BugReport navigationState={useLocation().state} />;
}
